import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { Option } from 'react-select/src/filters';

import type { TemplateClass } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';
import { Select } from '@feathr/components';
import { useLicense } from '@feathr/extender/hooks';

import { getOptions } from './TemplateTypeSelect.utils';
import TemplateTypeSelectLabel from './TemplateTypeSelectLabel';

export interface ITemplateTypeSelectOption extends ISelectOption {
  id: TemplateClass;
}

interface IProps {
  className?: string;
  onChange: (value?: TemplateClass) => void;
  value?: TemplateClass;
  wrapperClassName?: string;
}

function TemplateTypeSelect({ className, onChange, value, wrapperClassName }: IProps): JSX.Element {
  const { t } = useTranslation();
  const permissions = useLicense([
    'invites',
    'landingPage',
    'singleSend',
    'smartSend',
    'autoSend',
    'drip',
  ]);

  function filterOption({ label }: Option, inputValue: string): boolean {
    return label.toLowerCase().includes(inputValue.toLowerCase());
  }

  function onClearType(): void {
    onChange(undefined);
  }

  function onSelectType({ id }): void {
    onChange(id);
  }

  const typeOptions = getOptions(permissions);

  return (
    <Select
      className={className}
      filterOption={filterOption}
      formatOptionLabel={TemplateTypeSelectLabel}
      isClearable={true}
      name={'template-type-select'}
      onClear={onClearType}
      onSelectSingle={onSelectType}
      options={typeOptions}
      placeholder={t('Type')}
      value={typeOptions.find((option) => {
        return option.id === value;
      })}
      wrapperClassName={wrapperClassName}
    />
  );
}

export default TemplateTypeSelect;
